import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { Box, Link as MuiLink, Stack, Typography } from '@mui/material';

import type { ContentText } from 'src/types/followUpInspirations';

import { styles } from './index.styles';

export const CONTENT_TEXT_FIELD_TEST_ID = 'content-text-field';

interface ContentListProps {
  content: ContentText;
  maxLines?: number;
}

const ContentTextField: FC<ContentListProps> = ({ content, maxLines }) => (
  <Stack
    sx={{
      height: '100%',
    }}
  >
    <Typography
      variant="h6"
      sx={styles.headline}
      data-test-id={CONTENT_TEXT_FIELD_TEST_ID}
    >
      {content.headline}
    </Typography>
    {Array.isArray(content.list) && !!content.list.length && (
      <Box sx={styles.listWrapper}>
        <Box
          component="ul"
          sx={{
            maxHeight: `${(maxLines || 10) * 20}px`,
            pl: 2.5,
            m: 0,
          }}
        >
          {content.list.map((item, i) => (
            <Box
              component="li"
              key={i}
              sx={{
                lineHeight: '20px',
              }}
            >
              {item.link ? (
                item.link.startsWith('/') ? (
                  <MuiLink component={Link} to={item.link}>
                    {item.text}
                  </MuiLink>
                ) : (
                  <MuiLink
                    href={item.link}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {item.text}
                  </MuiLink>
                )
              ) : (
                <span>{item.text}</span>
              )}
            </Box>
          ))}
        </Box>
      </Box>
    )}
  </Stack>
);

export default ContentTextField;
